// export const PATH_URL =  "http://172.16.12.145:3005/"
export const PATH_URL =  "https://ziskat-api.devtechnosys.tech/"
// export const PATH_URL =  "https://api.ziskat.com/"
export const API_BASE = PATH_URL+"admin"
export const IMAGE_BASE = PATH_URL
export const SOCKET_URL =  PATH_URL

export const BASE_API = API_BASE + "/api";
export const MAIN_URL = BASE_API + "/api/admin";
export const MOBILE_REGEX = /^[0-9]{10}$/;

// export const PASSWORDS_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%^&*?])[A-Za-z\d#$@!%^&*?]{8,}$/;
export const PASSWORDS_REGEX = /^(?=\S{8,})(?=\S)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\p{L}\p{N}\s]).*$/u;

export const EMAIL_REGEX = /^(?![.+-])([a-zA-Z0-9._+-]+)(?!\.)[a-zA-Z0-9]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
  
export const NOSPACE_REGEX = /^[^\s]+(\s+[^\s]+)*$/;

export const REMOVENBSP = /&nbsp;/
export const NOSPACE = "Spaces are not allowed";

export const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "video/mp4",
  "video/x-ms-wmv",
  "video/quicktime",
  "video/webm",
  "application/pdf",
  "text/plain",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const MULTIPLESPACE = /  +/g;

export const CARD_REGEX =
  /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/g;

export const NODIGITREGEX = /^([^0-9]*)$/;

export const DECIMALPATTERN = /^[0-9]+(\.[0-9]{1,2})?$/;

export const REMOVEHTML = /(<([^>]+)>)/gi;

export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const STATUS_OPTIONS = [
  { value: false, label: "Active" },
  { value: true, label: "Inactive" },
];

export const ADS_TYPE_OPTIONS = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
];

export const STATUS_OPTIONS_LIST = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];
export const ROLE_OPTIONS_LIST = [
  { value: "consumer", label: "Consumer" },
  { value: "dealer", label: "Dealer" },
];

export const AUCTION_STATUS_OPTIONS_LIST = [
  { value: "live", label: "Live" },
  { value: "upComming", label: "Upcoming" },
  { value: "expired", label: "Expired" },
  { value: "completed", label: "Completed" },
];

export const Verification_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "cancelled", label: "Cancelled" },
];
export const PLAN_OPTIONS = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

export const SUPPORT_OPTIONS_LIST = [
  { value: "resolved", label: "Resolved" },
  { value: "pending", label: "Pending" },
  { value: "inProgress", label: "In Progress" },
];

export const Role_OPTIONS_LIST = [
  { value: "guest", label: "Guest" },
  { value: "user",  label: "User" },
];

export const CATEGORY_LIST = [
  { value: "all-events", label: "All Events" },
  { value: "sports", label: "Sports" },
  { value: "concerts", label: "Concerts" },
  { value: "shows", label: "Shows" },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { label: "Dealer", value: "dealer" },
  { label: "Consumer", value: "consumer" }
];

export const KYC_STATUS_OPTIONS = [
  { label: "Not Submitted", value: "not_submitted" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" }
];

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyB6iebTOoiAPNWs-bbpwnr4YxNTpgQBFJM";